import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MapaService } from '../../../services/mapa.service';
import { PanelAdministracionService } from '../../../../panel-vigilancia/services/panel-administracion.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'kt-alertas',
	templateUrl: './alertas.component.html',
	styleUrls: ['./alertas.component.scss']
})
export class AlertasComponent implements OnInit {
	public datosAlertado;
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public showNavigationButtons: boolean;
	public showPageSizeSelector: boolean;
	public isDisabled: boolean = true;
	public datosReporte = [];

	constructor(private panelService: PanelAdministracionService, private mapaService: MapaService,
		private dialogRef: MatDialogRef<AlertasComponent>,
		@Inject(MAT_DIALOG_DATA) private data, private toastr: ToastrService) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
	}

	ngOnInit() {
		this.datosAlertado = this.data[0];
		this.datosAlertado.datos.forEach(dato => {
			this.datosReporte.push({
				'Vehiculo': dato.descripcion,
				'Placas': dato.placas
			});
		});
		this.datosAlertado.datos.forEach(p => {
		 	this.datosReporte.push({
		 		'Evento': p.descripcionAlarma,
		 		'Nombre':p.nombre,
		 		'Modelo':p.modelo,
		 		'Número Seríe':p.numeroSerie,
		 		'Descripción':p.descripcion,
			});
		});
		if (this.datosReporte.length > 0) {
			this.isDisabled = false;
		}
	}

	silenciarAlarma(data) {
		console.log(data)
		this.panelService.apagarAlarmaPanel(data.devIndex).subscribe(result => {
			this.toastr.success("Alarma Silenciada")
			this.dialogRef.close();
		})
	}

	ubicarVehiculo(data) {
		this.dialogRef.close();
		this.mapaService.verVehiculo(data);
	}

	ubicarPanel(data) {
		this.dialogRef.close();
		this.mapaService.verPanel(data);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
